import React from 'react'
import HeroSection from '../OutletTemplate/HeroSection'
import CaseStudiesSection from '../HomeLanding/ComponentsIndiaPage/CaseStudiesSection'
import NewFaqSection from '../HomeLanding/HomeLandingComponents/NewFaqSection'
import NewsAndVideos from '../HomeLanding/ComponentsIndiaPage/NewsAndVideos'
import FeaturesSection from '../OutletTemplate/FeaturesSection'
import styles from '../.././styles/outletTemplate.module.css'
import ReviewsSection from '../HomeLanding/ComponentsIndiaPage/ReviewsSection'
import BusinessUnlockSection from '../HomeLanding/ComponentsIndiaPage/BusinessUnlockSection'
import ConnectWithUs from '../HomeLanding/ComponentsIndiaPage/ConnectWithUs'
import { IAAPISection, NewMarqueeComponentHomePageIndia, ParksFeaturesSection, QueueBusterExperienceCentersSection, ThemeParkReviewsSection } from '../qbStrap'
import Image from 'next/image'


const DesktopKidsPlayArea = () => {
    const topSection = [
        {
            title: <>The Right Billing Software for<br /> Kids Play Areas! </>,
            text: "Managing a kids play zone means quick billing, timed play sessions, handling party bookings, selling merchandise and F&B, all at once. QueueBuster turns every shriek of laughter into a seamless business operation. From speed-billing at the entry counter to real-time inventory management, QueueBuster keeps your play zone buzzing with joy, without the operational chaos, even on your busiest weekend.",
            centerImage: "/assets/kidsPlayArea/Desktop_image.webp",
            width: "72.4375rem",
            height: "48.625rem",
            top: "-32rem",
            left: "15rem",


            Image1: {
                src: "/assets/kidsPlayArea/all-tickets-sold.svg",
                alt: "All Tickets Sold",
                width: "14rem",
                height: "6.4rem",
                bottom: "32rem",
                left: "24rem",

            },
            Image2: {
                src: "/assets/kidsPlayArea/discount.svg",
                alt: "Up to 50% Off discount",
                width: "16rem",
                height: "6rem",
                bottom: "30rem",
                right: "22rem",
                zIndex: 10,
            },
            Image3: {
                src: "/assets/kidsPlayArea/redeem.svg",
                alt: "Redeem offers",
                width: "2.8125rem",
                height: "2.8125rem",
                bottom: "26.25rem",
                left: "45rem",
                zIndex: 12,
            },
            Image4: {
                src: "/assets/kidsPlayArea/quick-bill.svg",
                alt: "Quick Bill Created",
                width: "9.125rem",
                height: "9.8125rem",
                bottom: "9rem",
                left: "6rem",
                zIndex: 12,
            },
            Image5: {
                src: "/assets/kidsPlayArea/indoor-play-area.svg",
                alt: "Indoor Play Area ticket card",
                width: "9.8125rem",
                height: "10.3125rem",
                bottom: "13rem",
                right: "8rem",
                zIndex: 12,
            },

        }
    ]

    const faqs = [
        {
            para: (
                <span style={{ width: "90%" }}>
                    What makes QueueBuster the ideal billing solution for kids play zones?
                </span>
            ),
            des: "QueueBuster is purpose-built for the fast-moving, high-emotion environment of kids play zones, from managing timed play sessions and birthday party bookings to running snack counters and token dispensing simultaneously. Unlike generic POS systems, QueueBuster offers play zone-specific features like RFID wristband integration, slot-based entry management, and party hall reservation tools. Its intuitive interface requires minimal staff training, making it easy to deploy across every counter, zone, and activity hub in your venue.",
            id: 1,
            activeIndex: 1,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Can QueueBuster handle large groups like school trips or birthday parties?
                </span>
            ),
            des: "Absolutely. QueueBuster is built for high-volume, high-energy environments and has been deployed at some of India's busiest family entertainment centers handling thousands of visitors every weekend. The system supports simultaneous transactions across multiple entry points, F&B counters, and activity stations without any lag. Slot-based entry management helps you control crowd density in play zones and prevent bottlenecks at popular attractions, even when three birthday parties are running at the same time.",
            id: 2,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Can QueueBuster manage timed play sessions and zone-based access?
                </span>
            ),
            des: "Yes. QueueBuster allows you to set and manage timed play sessions with automated entry and exit tracking per guest. Zone-based access controls ensure children only enter areas they're booked for, useful for multi-zone venues with separate pricing for toddler areas, trampoline parks, or VR zones. Alerts notify staff when a session is nearing its end, helping manage smooth transitions even during peak hours without disruption to ongoing play.",
            id: 3,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does QueueBuster manage F&B across multiple counters in a play zone?
                </span>
            ),
            des: "QueueBuster provides a fully unified F&B management system that connects every snack kiosk, café, birthday catering counter, and party hall to a single backend. Real-time inventory tracking ensures stock levels are always visible and automatic alerts prevent mid-rush stockouts at busy counters. The quick-serve billing mode is designed for high-footfall environments where speed matters, reducing wait times for hungry kids and impatient parents alike. Outlet-wise performance reports help you identify bestsellers, track wastage, and plan smarter menus.",
            id: 4,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How secure are cashless transactions through QueueBuster's RFID system?
                </span>
            ),
            des: "Security is built into every layer of QueueBuster's cashless system. Each RFID wristband is uniquely encrypted and linked to a specific guest profile, so no unauthorized transactions can take place even if a wristband goes missing, which, with kids, does happen. Parents or staff can instantly freeze a wristband from the central dashboard, and any remaining balance can be refunded or transferred without hassle. All transactions are logged with timestamps and counter details, giving you a complete and tamper-proof audit trail.",
            id: 5,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How quickly can QueueBuster be set up at our play zone?
                </span>
            ),
            des: "QueueBuster is designed for fast, smooth deployment with minimal disruption to daily operations. Our onboarding team works closely with your management to understand your venue's zone layout, party hall structure, and operational workflow before configuring the system accordingly. Staff training is quick and simple thanks to QueueBuster's intuitive interface; most teams are fully operational within a couple of days. Ongoing technical support and regular software updates ensure your POS performs its best, whether it's a quiet Tuesday or a chaotic holiday weekend.",
            id: 6,
            activeIndex: 0,
        },
    ]
    const kidsPlayAreaFeatures = {
        centerImage2: "/assets/kidsPlayArea/kids-play-area-features.webp",
        data: [
            {
                id: 1,
                image: "/assets/kidsPlayArea/BoxOfficeTicketing_main.png",
                icon: "/assets/waterPark/BoxOfficeTicketing_icon.svg",
                title: "Instant Billing for Hyperactive Entry Counters",
                tag: "Box Office Ticketing",
                desc: <>QueueBuster POS is built for the non-stop rush of kids play zones, where parents are in a hurry, kids are already running ahead, and your staff needs to bill fast without making errors. The software processes timed entries, group packages, and add-on activities in seconds, keeping queues short and smiles wide from the very first swipe. <br />
                    With a clutter-free interface designed for speed, your staff can handle walk-ins, school group visits, and birthday party check-ins from a single screen.</>,
                btnText: "Book a Free Demo",
                imageWidth: "36.25rem",
                imageHeight: "37rem",
                Image1: {
                    src: "/assets/kidsPlayArea/package.svg",
                    alt: "Kids play area ticket item card",
                    imageWidth: "22rem",
                    imageHeight: "10rem",
                    top: "15rem",
                    right: "0rem",
                },
                Image3: {
                    src: "/assets/kidsPlayArea/quick-bill.svg",
                    alt: "Kids play area family package offer",
                    imageWidth: "14rem",
                    imageHeight: "15rem",
                    bottom: "15rem",
                    left: "5rem",
                },


                points: [
                    <>Rapid billing for timed play sessions, packages, and activity bundles</>,
                    <>Multiple payment modes - cash, card, UPI, and contactless support</>,
                    <>Minimal staff training with an intuitive, easy-to-navigate UI</>,
                    <>Works on POS terminal, smartphones, Android payment machines, tabs and more</>,
                ],
            },
            {
                id: 2,
                image: "/assets/kidsPlayArea/On-The-Go-Ticketing_main.png",
                tag: "On-The-Go Ticketing",
                icon: "/assets/waterPark/On-The-GoTicketing_icon.svg",
                title: "Sell Fast, Upsell Faster, Without The Counter Crunch",
                desc: <>With QueueBuster's On-The-Go Ticketing solution, you can sell anywhere inside your kids play area. Upsell tickets, retail items or F&B beyond just the main counter. This means less crowding at counters, incremental revenue generation, faster entry, and a far more relaxed experience for both parents and staff. <br />
                    All bookings, online, app-based, or walk-in, sync to a single real-time dashboard, so you always know exactly how many kids are inside and how many slots are left.</>,
                btnText: "Contact Sales",
                imageWidth: "36.25rem",
                imageHeight: "37rem",
                Image1: {
                    src: "/assets/kidsPlayArea/payPass.svg",
                    alt: "On-the-go payment pass selection",
                    imageWidth: "24.1rem",
                    imageHeight: "12.25rem",
                    top: "15rem",
                    right: "-1rem",
                },
                Image3: {
                    src: "/assets/kidsPlayArea/indoor.svg",
                    alt: "Kids play area time slot selection",
                    imageWidth: "14rem",
                    imageHeight: "20rem",
                    bottom: "-2rem",
                    left: "8rem",
                },


                points: [
                    <>Sell timed play passes, party packages, and add-ons from any channel</>,
                    <>Slash entry queues with pre-validated QR codes and digital passes</>,
                    <>Slot-based booking to control crowd density and ensure safety compliance</>,
                    <>Online and offline ticket data stays synchronized in real time</>,
                ],
            },
            {
                id: 3,
                image: "/assets/kidsPlayArea/OnlineTicketingEngine.png",
                tag: "Online Ticketing Engine",
                icon: "/assets/kidsPlayArea/ticket.svg",
                title: "Build your online booking engine. Sync it with Offline POS",
                desc: <>With QueueBuster's Online Ticketing Engine, your entire booking journey moves online - while staying perfectly in sync with your on-ground operations. From discovering your play area to booking tickets and add-ons, customers get a seamless digital experience, while you get complete control over capacity, inventory, and revenue. <br />
                    No more juggling between online bookings and counter entries. Every ticket booked online is instantly reflected at your POS, ensuring zero confusion, faster check-ins, and a smoother experience from entry to exit.</>,
                imageWidth: "36.25rem",
                imageHeight: "37rem",
                btnText: "Contact Sales",

                Image1: {
                    src: "/assets/kidsPlayArea/selecting.svg",
                    alt: "RFID wristband payment confirmation",
                    imageWidth: "15.25rem",
                    imageHeight: "5.2rem",
                    top: "14rem",
                    right: "1rem",
                },
                Image3: {
                    src: "/assets/kidsPlayArea/selectTime.svg",
                    alt: "Indoor play zone access card",
                    imageWidth: "24rem",
                    imageHeight: "12rem",
                    bottom: "-1rem",
                    left: "8rem",
                },

                points: [
                    <>Create a fully branded online ticketing flow tailored to your business</>,
                    <>Sell tickets, F&B combos, party packages, and more during the booking journey</>,
                    <>Enable instant confirmations with QR-based digital tickets</>,
                    <>Generate incremental revenue for your business</>,
                ],
            },
            {
                id: 4,
                image: "/assets/kidsPlayArea/F&B-Restaurant_main.png",
                tag: "F&B and Restaurant POS Billing",
                icon: "/assets/waterPark/F&B_icon.svg",
                title: "Cafe or Food Court Managed Effortlessly",
                desc: <>Whether it's a restaurant, pizzeria, snack counters, or a dedicated food court setup, QueueBuster manages every F&B outlet in your play zone from a single backend. Real-time inventory tracking means your bestselling snack combos never run out on a packed Saturday afternoon. <br />
                    Automated reports help you identify what sells, cut wastage, and keep party packages profitable, so your food business runs as smoothly as the ball pit.</>,
                imageWidth: "36.25rem",
                imageHeight: "37rem",
                btnText: "Book a Free Demo",
                Image1: {
                    src: "/assets/kidsPlayArea/item.svg",
                    alt: "F&B outlet performance reports",
                    imageWidth: "15.3rem",
                    imageHeight: "15rem",
                    bottom: "5rem",
                    right: "0rem",
                },
                Image3: {
                    src: "/assets/kidsPlayArea/occupied.svg",
                    alt: "Play zone occupancy analytics",
                    imageWidth: "24rem",
                    imageHeight: "7rem",
                    top: "14rem",
                    left: "0rem",
                },


                points: [
                    <>Unified billing across all F&B counters, kiosks, and party areas</>,
                    <>Live inventory alerts to prevent stockouts during weekend rushes</>,
                    <>Flexibility to bundle F&B items with play packages at the billing counter</>,
                    <>Outlet-wise performance reports for smarter menu and pricing decisions</>,
                ],
            },
            {
                id: 5,
                image: "/assets/kidsPlayArea/Omnichannel_main.png",
                tag: "Omnichannel Booking",
                icon: "/assets/waterPark/Omnichannel_icon.svg",
                title: "One Dashboard. Zero Chaos",
                desc: <>Whether families book through your website, Instagram link, or simply walk in, QueueBuster's Omnichannel Booking Engine pulls every reservation into a single, real-time control panel. No double-booked party halls, no overbooking on school trip days, no frantic phone calls, just clean visibility across every channel. <br />
                    Especially powerful for play zones running weekend birthday slots, holiday camp packages, and school group visits simultaneously across multiple booking platforms.</>,
                imageWidth: "36.25rem",
                imageHeight: "37rem",
                btnText: "Contact Sales",
                Image1: {
                    src: "/assets/kidsPlayArea/play_zone.svg",
                    alt: "Live slot capacity indicator",
                    imageWidth: "22rem",
                    imageHeight: "10rem",
                    top: "14rem",
                    right: "0rem",
                },
                Image3: {
                    src: "/assets/kidsPlayArea/reports.svg",
                    alt: "Omnichannel booking calendar",
                    imageWidth: "18rem",
                    imageHeight: "16rem",
                    bottom: "2rem",
                    left: "4rem",
                },


                points: [
                    <>Consolidate walk-in, online, and partner bookings on one platform</>,
                    <>Prevent overbooking with live slot and capacity management</>,
                    <>Real-time sync ensures no channel lag or booking mismatch</>,
                    <>Manage group bookings, birthday party slots, and bulk entries with ease</>,
                ],
            },


        ]
    };

    const parksFeatures = [
        {
            id: 1,
            image: "/assets/kidsPlayArea/FECs.png",
            title: "FECs",
        },
        {
            id: 2,
            image: "/assets/kidsPlayArea/KidsPlayAreas.png",
            title: "Kids Play Areas",
        },
        {
            id: 3,
            image: "/assets/kidsPlayArea/TrampolineZones.png",
            title: "Trampoline Zones",
        },
        {
            id: 4,
            image: "/assets/kidsPlayArea/Event&PartyHalls.png",
            title: " Party & Event Halls",
        },
        {
            id: 5,
            image: "/assets/kidsPlayArea/RetailMerchandise.png",
            title: "Retail & Merchandise",
        },
        {
            id: 6,
            image: "/assets/kidsPlayArea/F&B _Counters.png",
            title: "F&B Counters ",
        }

    ]


    const themeParkClients = [
        { imgSrc: "/assets/HomeLanding/QBIcons/shivalaya1.svg", altText: "Shivalaya 1", height: "10rem", width: "15rem" },
        { imgSrc: "/assets/themePark_icons/dizzie.svg", altText: "Dizzee World", height: "10rem", width: "15rem" },
        { imgSrc: "/assets/themePark_icons/sgnp.svg", altText: "SGNP", height: "10rem", width: "15rem" },
        { imgSrc: "/assets/themePark_icons/kochui.svg", altText: "Kochi", height: "10rem", width: "15rem" },
        { imgSrc: "/assets/themePark_icons/escape.svg", altText: "Escape Water Park", height: "10rem", width: "15rem" },
        { imgSrc: "/assets/themePark_icons/vedvan.svg", altText: "Vedvan", height: "10rem", width: "15rem" },
        { imgSrc: "/assets/themePark_icons/bekal.svg", altText: "Bekal", height: "10rem", width: "15rem" },
        { imgSrc: "/assets/themePark_icons/wtfun.svg", altText: "WTFun", height: "10rem", width: "15rem" },
        { imgSrc: "/assets/themePark_icons/tamil.svg", altText: "Tamil Nadu Tourism", height: "10rem", width: "15rem" },
        { imgSrc: "/assets/themePark_icons/telangana.svg", altText: "Telangana Tourism", height: "10rem", width: "15rem" },
        { imgSrc: "/assets/themePark_icons/odisha.svg", altText: "Odisha Tourism", height: "10rem", width: "15rem" },
        { imgSrc: "/assets/themePark_icons/bengaluru.svg", altText: "Bengaluru Tourism", height: "10rem", width: "15rem" },
        { imgSrc: "/assets/themePark_icons/mojoland.svg", altText: "Mojoland", height: "10rem", width: "15rem" },
        { imgSrc: "/assets/themePark_icons/hpca.svg", altText: "HPCA", height: "10rem", width: "15rem" },
    ]



    return (
        <div style={{ fontFamily: "GilroyMedium" }}>
            <HeroSection data={topSection} />
            <div style={{ maxWidth: "1850px", margin: "0 auto", padding: "0 19rem", boxSizing: "border-box", overflow: "hidden" }}>
                <div style={{ position: "relative", zIndex: 1 }}>
                    <NewMarqueeComponentHomePageIndia
                        speed={100}
                        ClientsArr={themeParkClients}
                        style={{
                            width: "100%",
                            backgroundColor: "transparent",
                            display: "flex",
                            justifyContent: "center",
                            margin: "2rem auto",
                        }}
                    />

                </div>
            </div>
            <div style={{ maxWidth: "1850px", margin: "0 auto", padding: "0 9rem", boxSizing: "border-box" }}>
                <IAAPISection />
            </div>


            <div className={styles.features_section} style={{ maxWidth: "1850px", margin: "5rem auto", padding: "0 0rem", boxSizing: "border-box" }}>
                <div className={styles.features_section_badge}>
                    <h1>Smart Features of Billing Software for Kids Play Area!</h1>
                </div>
                <FeaturesSection data={kidsPlayAreaFeatures.data} centerImages={[kidsPlayAreaFeatures.centerImage2]} />
            </div>

            <div style={{ maxWidth: "1850px", margin: "0 auto", padding: "0 9rem", boxSizing: "border-box" }}><ParksFeaturesSection data={parksFeatures} title="Arcades, Bowling, Food Courts, Adventure Climb Zones, We Power it all!" /></div>

            <div style={{ maxWidth: "1850px", margin: "0 auto", padding: "0 18rem", boxSizing: "border-box" }}>
                <div className={styles.section_heading} >
                    <h3 style={{ fontSize: "2.5rem" }}>The QueueBuster Experience</h3>

                </div>
                <QueueBusterExperienceCentersSection />
            </div>
            <div style={{ maxWidth: "1850px", margin: "0 auto", padding: "0 8rem", boxSizing: "border-box" }}><ThemeParkReviewsSection /></div>


            <div className={styles.featuresSection}><br />

                <div><BusinessUnlockSection /></div>
                <div><CaseStudiesSection /></div>
                <div style={{ margin: "0 0rem 8rem 0rem " }}> <ConnectWithUs /></div>

                <NewFaqSection FaqTableData={faqs} heading={"FAQ's for the QueueBuster Kids Play Area billing software"} />
                <div>
                    <NewsAndVideos />
                </div>
            </div>

        </div>
    )
}

export default DesktopKidsPlayArea
